<template>
  <div>
    <!-- 数据库 -->
    <div class="databases">
        <Row :gutter="10">
            <Col span="4">
                <Button type="primary" @click="addModal()">{{ $t('smartMonitor.applicationSystem.addDatabase') }}</Button>
            </Col>
        </Row>
    </div>
    <Modal v-model="modal" :title="$t('smartMonitor.applicationSystem.addDatabase')" width="900px;" :loading="modalLoading" :ok-text="$t('MCM.automaticalMaintenanceReport.add')" :mask-closable="false" :closable="false">
        <Form :model="databasesForm" :label-width="40" ref="databasesForm">
            <!-- 搜索 -->
            <Row :gutter="16">
                <Col span="8">
                    <!-- 账户 -->
                    <FormItem :label="$t('smartMonitor.applicationSystem.account')" prop="account">
                        <Select v-model="databasesForm.account"
                            @on-change="changeAccount(databasesForm.account)" :transfer="true">
                            <Option :value="item.id" v-for="(item,index) in accountList" v-bind:key="index">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="8">
                    <!-- 存储区域 -->
                    <FormItem :label="$t('smartMonitor.applicationSystem.region')" prop="region">
                        <Select @on-change="changebackupRegion(databasesForm.region)"
                            v-model="databasesForm.region" :transfer="true" multiple :max-tag-count="1">
                             <Checkbox v-model="singleBackupRegion" @on-change="selectBackupRegionAll" style="display: block;text-align:right;">{{ $t('configuration_management.customized_alarm_config.checkAll') }}</Checkbox>
                            <Option :value="item.name" v-for="item in regionList" :key="item.id">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="6" v-show="isDatabaseEngines">
                    <!-- 数据库引擎 -->
                    <FormItem :label="$t('alarms.database.engine')" prop="databaseEngines">
                        <Select v-model="databasesForm.databaseEngines" @on-change="changeDatabaseEngines(databasesForm.databaseEngines)" :transfer="true">
                            <Option  :value="item.name" v-for="item in databaseEnginesList" :key="item.id">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Button type="primary" style="float:right;" v-show="isShowSearch" @click="searchDatabaseInput()">{{ $t('alarms.common.search') }}</Button>
            </Row>
            <Table :no-data-text="$t('common.noData')" ref="selection" :columns="columns" :loading="loading" :data="queryAccountDatabasesData" :height="400" @on-selection-change="getSelection"></Table>
        </Form>
        <div slot="footer">
            <Button @click="handleReset('databasesForm')">{{ $t('RIAccountGroupManagement.cancel') }}</Button>
            <Button type="primary" @click="handleSubmit('databasesForm')" :loading="addloading" :disabled="isDisable">{{ $t('alarms.common.add') }}</Button>
        </div>
    </Modal>
    <table-databases></table-databases>
  </div>
</template>

<script>
    import {getCookie} from '../../../../../../utils/cookieUtil.js'
    import TableDatabases from '../rds/TableDatabases'
    var tableDatabases = TableDatabases
    export default {
        name: 'AddDatabases',
        components: {
          TableDatabases
        },
        data () {
            return {
                singleBackupRegion:false,
                databasesForm: {
                    account: '',
                    region: [],
                    databaseEngines:''
                },
                databaseEnginesList:[],
                accountList: [],
                regionList: [],
                selection: [],
                modal: false,
                modalLoading: true,
                loading: false,
                addloading:false,
                isDisable: true,
                isShowSearch: false,
                isDatabaseEngines:false,
                columns: [
                {
                    type: 'selection',
                    width: 60,
                    align: 'center'
                },
                {
                    title: this.$t('alarms.database.databaseId'),
                    key: 'databaseId'
                },
                {
                    title: this.$t('alarms.database.engine'),
                    key: 'engine'
                },
                {
                    title: this.$t('alarms.database.instanceType'),
                    key: 'type'
                },
                {
                    title: this.$t('alarms.database.state'),
                    key: 'stateName'
                },
                {
                    title: this.$t('alarms.database.region'),
                    key: 'region'
                }],
                queryAccountDatabasesData: [],
                newQueryAccountDatabasesDataList: []
            }
        },
        methods: {
            addModal:function(){
                this.modal=true;
                this.selectAccountByCloudPlatform();
                if(this.$route.query.type==2){
                    this.isDatabaseEngines=true;
                    this.queryDatabaseEngines();
                }else{
                    this.isDatabaseEngines=false;
                }
            },
            // 查询数据库引擎
            queryDatabaseEngines:function(){
                this.$api.rds.queryDatabaseEngines("userName",getCookie(global.cookieName))
                .then(res => {
                    this.databaseEnginesList = res.data;
                })
            },
            //查询账号
            selectAccountByCloudPlatform: function(){
                this.$api.account.selectAccountByCloudPlatform("type",this.$route.query.type)
                .then(res => {
                    this.accountList = res.data; 
                })
            },
            // 切换账户
            changeAccount: function () {
                if (this.databasesForm.account == "" || this.databasesForm.account == null) {
                    return;
                }
                this.databasesForm.databaseEngines='';
                this.databasesForm.region = [];
                this.isShowSearch = true;
                this.$api.account.queryAccountRegions("accountId", this.databasesForm.account)
                .then(res => {
                    this.regionList = res.data;
                })
            },
            /***********存储区域**************************/
            selectBackupRegionAll(){
                this.databasesForm.region = []
                if (this.singleBackupRegion) {
                    this.regionList.map((item) => {
                        this.databasesForm.region.push(item.name)
                    })
                } else {
                    this.databasesForm.region = []
                }
            },
            // 切换存储区域
            changebackupRegion: function (val) {
                if (val.length === this.regionList.length&&val.length!=0) {
                    this.singleBackupRegion = true
                } else {
                    this.singleBackupRegion = false
                }
                this.databasesForm.databaseEngines='';
                this.queryAccountDatabasesData = [];
                this.isShowSearch = true;
            },
            // 数据库引擎
            changeDatabaseEngines:function(){
                this.queryAccountDatabasesData=[];
                this.isShowSearch=true;
            },
            // 当前选择checkbox
            getSelection: function (selection) {
                this.selection = selection;
                // 清空数组
                this.newQueryAccountDatabasesDataList = [];
                for (var i = 0; i < this.selection.length; i++) {
                    // 状态
                    var TableQueryDatabaseDataCopy = new Object();
                    TableQueryDatabaseDataCopy.ticketCompanyMonitorItemVariablesId=this.$route.query.id;
                    TableQueryDatabaseDataCopy.resourceId=this.selection[i].id;
                    TableQueryDatabaseDataCopy.resourceType=this.$route.query.monitorModule;
                    this.newQueryAccountDatabasesDataList.push(TableQueryDatabaseDataCopy);
                }

                // 选了数据 可以点击下一步
                if (this.newQueryAccountDatabasesDataList.length == 0) {
                    this.isDisable = true;
                } else {
                    this.isDisable = false;
                }
            },
            // 点击查询
            searchDatabaseInput: function () {
                if (this.databasesForm.account == "" || this.databasesForm.account == null || this.databasesForm.region == [] || this.databasesForm.region == null) {
                    return;
                }
                this.loading = true;
                //数据库列表
                this.$api.alertRuleExceptionResource.listNotExceptionResource({
                    "regions": this.databasesForm.region,
                    "accountId": this.databasesForm.account,
                    "engineType": this.databasesForm.databaseEngines,
                    "monitorModule": this.$route.query.monitorModule,
                    "ticketCompanyMonitorItemVariablesId": this.$route.query.id
                }).then(res => {
                    this.queryAccountDatabasesData = res.data;
                    this.loading = false;
                })
            },
            // 添加
            handleSubmit: function (name) {
                this.$refs[name].validate(valid => {
                    if(valid){
                        // 增加
                        this.addloading=true;
                        this.$api.alertRuleExceptionResource.batchCreate({
                            "alertRuleExceptionResourceDTOS":this.newQueryAccountDatabasesDataList
                        }).then(res => {
                            setTimeout(() => {
                                tableDatabases.methods.showAllDatabase();
                                this.$refs[name].resetFields();
                                this.modalLoading = false;
                                this.$nextTick(() => {
                                    this.modalLoading = true;
                                });
                                this.$Message.success(this.$t('common.addSuccess'));
                                this.queryAccountDatabasesData=[];
                                this.newQueryAccountDatabasesDataList=[];
                                this.modal = false;
                                this.addloading=false;
                                this.isDisable = true;
                                this.isShowSearch=false;
                            }, 1000);
                        })
                    }else{
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.modalLoading = false;
                        setTimeout(() => {
                            this.modalLoading = true
                        }, 0)
                        this.$Message.error(this.$t('common.addFail'));
                    }
                });
                    
            },
             // 取消
            handleReset: function (name) {
                this.isDisable = true;
                this.modal = false;
                this.isShowSearch=false;
                this.queryAccountDatabasesData=[];
                this.newQueryAccountDatabasesDataList=[];
                this.$refs[name].resetFields();
            }
        }
    }
</script>

<style scoped>
  /*databases*/
  .databases {
    width: 100%;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/customer_defined_alarm_configuration/exception_resource/rds/AddDatabases.vue